import type { GdprConfig } from '#src/app/pages/petitionDetails/shared/hooks';
import type { FormValues, NormalizedFormValues } from '#src/app/pages/petitionDetails/shared/types';

import { isGdprEnabled } from '../isGdprEnabled';

export function normalizeGdprConsent(
	{ countryCode, gdprConsent }: Pick<FormValues, 'countryCode' | 'gdprConsent'>,
	gdprConfig: GdprConfig,
): NormalizedFormValues['marketingCommsConsent'] {
	if (!isGdprEnabled(countryCode, gdprConfig)) return null;

	const { copy, overridden, radiosRemoved } = gdprConfig;

	if (radiosRemoved) {
		return {
			consentGiven: false,
			name: 'global_consent_initial_eu_exp_sign_form_gdpr_radio_removal_v1',
			text: '[no UI shown] defaulted to opt-out',
		};
	}

	return {
		consentGiven: gdprConsent === 'true',
		name: overridden ? 'global_consent_initial_eu_exp_control' : 'global_consent_initial_eu_default',
		text: copy.prompt || copy.opt_in,
	};
}
